/* eslint-disable react/jsx-indent */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'rsuite';
import { selectorDataPointsExhibitionType, SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN } from '../../../../../reducers/gerenciadorPrecos';
import { RowData } from '../../../../../reducers/gerenciadorPrecos/datapoints';
import { RESET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS } from '../../../../../reducers/getFamilyClusterModal/datapoints';
import { CLEAR_EDITED_FAMILY_CLUSTER_DATAPOINTS } from '../../../../../reducers/getFamilyClusterModal/editedFamilyClusterDatapoints';
import { CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS } from '../../../../../reducers/getStoreFamilyClusterModal/editedStoreFamilyClusterDatapoints';
import styles from './GetFamilyClusterModal.module.scss';
import { GetFamilyClusterTable } from './components/GetFamilyClusterTable';

type GetFamilyClusterModalProps = {
  rowData: RowData;
  show: boolean;
  onHide: () => void;
};

export const GetFamilyClusterModal = ({ rowData, show, onHide }: GetFamilyClusterModalProps) => {
  const { clusterId, objectiveMargin, clusterName, productId, productFamilyId, storeId, description, clusterItemsCount } = rowData;

  const dispatch = useDispatch();

  const closeGetFamilyClusterModal = () => {
    onHide();
    dispatch(SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN(false));
    dispatch(CLEAR_EDITED_STORE_FAMILY_CLUSTER_DATAPOINTS());
    dispatch(CLEAR_EDITED_FAMILY_CLUSTER_DATAPOINTS());
    dispatch(RESET_GET_FAMILY_CLUSTER_MODAL_DATAPOINTS());
  };

  const datapointExhibitionType = useSelector(selectorDataPointsExhibitionType);
  return (
    <Modal show={show} onHide={closeGetFamilyClusterModal} className={styles['cluster-family-modal']}>
      <Modal.Header>
        <Modal.Title className={styles['modal-title']}>Família de produto</Modal.Title>
        <div className={styles['header-container']}>
          <div className={styles['header-container__row']}>
            <div className={styles['header-container__content']}>
              <p>FAMÍLIA DE PRODUTO</p>
              <span>{productFamilyId}</span>
            </div>
            <div className={styles['header-container__content']}>
              <p>TOTAL DE PRODUTOS</p>
              <span>{rowData.itemsCountFamily || '--'}</span>
            </div>
            <div className={styles['header-container__content']}>
              <p>PRODUTO PAI</p>
              <span>
                {productId} - <span className={styles['info']}>{description}</span>
              </span>
            </div>
          </div>
          <div className={styles['header-container__row']}>
            <div className={styles['header-container__content']}>
              <p>CLUSTER</p>
              <span>{clusterName}</span>
            </div>
            <div className={styles['header-container__content']}>
              <p>TOTAL DE LOJAS</p>
              <span>{clusterItemsCount}</span>
            </div>
            <div className={styles['header-container__content']}>
              <p>MARGEM OBJETIVA</p>
              {objectiveMargin ? <span>{objectiveMargin?.toFixed(1)}%</span> : <span>--</span>}
            </div>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GetFamilyClusterTable
          onHide={onHide}
          productId={productId as string}
          storeId={storeId as string}
          productFamilyId={productFamilyId as string}
          clusterId={clusterId as string}
          datapointExhibitionType={datapointExhibitionType}
        />
      </Modal.Body>
    </Modal>
  );
};
